module.exports = __webpack_public_path__ + "img/hakhak_app_6.9fc2fe96.png";